<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <b-row class="mx-0 mb-3">
      <b-col lg="12">
        <b-card
          title="Paramètres sur les mandats"
          class="bg-light shadow"
          title-tag="h6"
        >
          <b-row>
            <template v-for="(section, id_section) in parameters">
              <b-col :key="id_section" lg="12">
                <template
                  v-for="(parameter, id_parameter) in section.parameters"
                >
                  <div
                    :key="id_parameter"
                    :class="
                      parameter.mh_class.value
                        ? parameter.mh_class.value
                        : 'col-lg-12'
                    "
                  >
                    <mh-input
                      :label="ucfirst(parameter.variable.value)"
                      field="value"
                      :table="parameter"
                      :append="
                        parameter.unity.value ? parameter.unity.value : null
                      "
                      :rows="
                        parameter.data.value.rows
                          ? parameter.data.value.rows
                          : null
                      "
                      labelColsLg="0"
                    ></mh-input>
                    <b-button
                      @click="save()"
                      size="sm"
                      class="mt-2"
                      variant="success"
                      >Enregistrer</b-button
                    >
                  </div>
                  
                </template>
                
              </b-col>
              
            </template>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import parameters from "@/services/parameters.js";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "ManageSeuil",
  components: { MhInput },
  data() {
    return {
      parameters: [],
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Seuil d'alerte pour les MD1",
          active: true,
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      parameters.list().then((response) => {
        this.parameters = response.data.filter((x) => x.section == "Mandats");
      });
    },
    save() {
      parameters.save(this.parameters).then(() => {
        this.$bvToast.toast("Paramètres mis à jour", {
          title: `Recuperator`,
          toaster: "b-toaster-top-right",
          variant: "success",
          autoHideDelay: 2000,
          solid: false,
        });
      });
    },
    ucfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
};
</script>
